import { render, staticRenderFns } from "./TrulyEmpty.vue?vue&type=template&id=76c9ffa4"
import script from "./TrulyEmpty.vue?vue&type=script&lang=js"
export * from "./TrulyEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports